import React from "react"
import LoadingAnimation from "@kit/design/loading-animation"

export const Loading = () => (
  <div className="flex justify-center">
    <LoadingAnimation />
  </div>
)
